/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A generic error
 */
export interface GeneralResponse { 
    /**
     * The http code.
     */
    readonly status: number;
    /**
     * A status message.
     */
    readonly message: string;
}

